<template>
  <div class="gallery" style="width: 100%; height:100%;">
    <div id="myModal1" class="modal fade-custom" style="display: none; cursor: pointer" role="dialog">
      <div class="modal-dialog" style="width:80%">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-body" style="cursor: initial">
            <div class="header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <!-- On IE &times; doesn't look like 'x' even with charset utf-8  -->
                <!--<span aria-hidden="true" class="close-cross-button">x</span>-->
                <!-- Define closeWithSpace in config.json, this will make a border at top of the gallery
                     and the top right corner is a invisible close button, use this when the close button
                     is baked in the gallery frame -->
                <!--<span aria-hidden="true" class="close-cross-button">&nbsp;&nbsp;&nbsp;</span>-->
              </button>
            </div>
            <div id="myCarousel1" class="carousel slide" data-ride="carousel1" data-interval="false" data-wrap="false">
              <!-- Wrapper for slides -->
              <div class="carousel-inner">
                <!-- Set active class for the first element[0] -->
                <div v-for="(image, index) in galleryImages" class="item" v-bind:class="{ 'active': index==0 }">
                  <img :src="image.src" style="width:auto; cursor:default">
                </div>
              </div>
              <!-- Left and right controls -->
            </div>
            <div class="footer">
              <!-- Left and right controls -->
              <a class="left carousel-control" href="#myCarousel1" data-slide="prev">
                <div class="arrow-left arrow"></div>
                <span class="glyphicon controller-gallery"
                      style="padding-left: 10px">Prev</span>
                <span class="sr-only">Previous</span>
              </a>
              <span class="glyphicon controller-gallery imageCounter">{{currentIdx}}/{{totalImages}}</span>
              <a class="right carousel-control" href="#myCarousel1" data-slide="next">
                <span class="glyphicon controller-gallery"
                      style=" padding-right: 10px">Next</span>
                <div class="arrow-right arrow"></div>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '../assets/js/event-bus';
  // import { mapState, mapActions, mapMutations } from 'vuex';
  export default {
    name: 'app-dash-gallery',
    computed: {
      galleryImages() {
        return this.gallery.images;
      },
    },
    created() {
      this.goingToHide = null;
    },
    mounted() {
      $('#myModal1').on('hidden.bs.modal', function () {
        // console.log('gallery hides');
        EventBus.$emit('blur-video', false);
        this.gallery.images = []; // pass in empty object to unload images when hide.
      }.bind(this));
    },
    methods: {
      autoHide(millsec) {
        // cancel previous hide function
        if (this.goingToHide) {
          this.cancelHide();
        }
        // console.log('autohide galllery in ' + millsec)
        const that = this;
        this.goingToHide = setTimeout(() => {
          that.hide();
        }, millsec);
      },
      cancelHide() {
        // console.log('Cancel Hide ;');
        clearTimeout(this.goingToHide);
      },
      hide() {
        // console.log('Gallery hide();');
        $('#myModal1').modal('hide');
      },
      show(gallery) {
        // debugger;
        const comp = this;

        EventBus.$emit('blur-video', true);
        // Assign gallery data
        // At this point, the component knows about the gallery
        // And the image item will be updated. The modal dialog
        // is being created at this point.
        // gallery deep clone so we can update the gallery internally without effecting the object.
        this.gallery = JSON.parse(JSON.stringify(gallery));
        this.totalImages = gallery.images.length;
        this.currentIdx = 1;
        this.is360 = gallery.is360;
        const hideInMS = gallery.autoHide;  // if autoHide is specify in number (ms), then gallery will auto hide itself.
        // const hideInMS = 5000;
        // this.additionalPadding = 22;
        this.additionalPadding = 0;


        if (gallery.hasOwnProperty('width')) {
          $('.modal-dialog').width(gallery.width + this.additionalPadding + "px");
          $('#myCarousel1').carousel(0);
          $('#myModal1').modal('show');
          $('#myModal1').show();
        } else {
          // Finding image dimensions dynamically, then showing the Galley with specific width
          var img = new Image();
          img.onload = function () {
            var theDialogFrame = this.additionalPadding;

            // console.log(this.width + "px is the image width");
            $(".modal-dialog").width(this.width + theDialogFrame + "px");

            $('#myCarousel1').carousel(0);
            $('#myModal1').modal('show');
            $('#myModal1').show();
          }
          img.src = gallery.images[0].src;
        }
        // debugger;
        $('.left').hide();

        if (gallery.images.length > 1) {
          $('.right').show();

        } else {
          $('.right').hide();
          $('.footer').hide();
        }

        // setup auto hide gallery
        if (typeof hideInMS === 'number') {
          this.autoHide(hideInMS);
        }

        // We can monitor the events based on the carousel.
        // on carousal slide check which indicator to hide and show
        $('#myCarousel1').on('slide.bs.carousel', function (e) {
          // debugger;
          var active = $(e.target).find('.carousel-inner > .item.active');
          var next = $(e.relatedTarget);
          var currentIndex = next.index();
          var carouselData = $(this).data('bs.carousel');

          var itemLength = carouselData.$items.length;
          comp.currentIdx = currentIndex + 1;
          // console.log( 'curr index is ' + comp.currentIdx);

          // debugger;
          if (carouselData.$items.length > 1) {
            if (currentIndex >= 1) {
              $('.left').show();
            } else {
              $('.left').hide();
            }
            if (currentIndex === (itemLength - 1)) {
              $('.right').hide();
              $('.left').show();
            } else {
              $('.right').show();
            }
          }
        });
      },
      getImages() {
        return this.gallery.images;
      },
    },
    data() {
      return {
        currentIdx: 0,
        totalImages: 0,
        gallery: [],
        images: [],
        is360: false,
      };
    },
  };
</script>

<style lang="css" rel="stylesheet/css" scoped>
  .close-cross-button {
    color:#fff;
    font-size:50px;
    padding: 10px;
  }

  .footer {
    position:relative;
    height:60px;
  }

  /* handle web version here, build app for 1080P */
  @media screen and  (max-height: 720px) {
    @media screen and  (max-width: 1280px) {
      .controller-gallery {
       font-size: 20px;
       line-height: 45px;

      }
      .close{
        padding:2px;
      }
      .close-cross-button {
        font-size:50px;
      }
      .footer{
        height:45px;
      }
    }
  }

  .animated-gallery {
    -webkit-animation-duration: 0.2s;
    animation-duration: 0.2s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  @-webkit-keyframes fadeInUp2 {
    from {
      opacity: 0;
      -webkit-transform: translate3d(0, 10%, 0);
      transform: translate3d(0, 10%, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }

  @-webkit-keyframes fadeOutDown2 {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: translate3d(0, 10%, 0);
      transform: translate3d(0, 10%, 0);
    }
  }

  /**
   We put in the fade effect to minimize the transition from opacity 0->1
   to 0.5->1 or 1->0.5  As there are flashes during modal goes away because
   0.15 sec to transition from opactiy 1->0 wasn't smooth.  So we make it
   1->0.5, then modal dialog goes away.
   */
  .fade.in {
    opacity: 1;
  }

  .fade {
    opacity: .5;
  }

  .fade-gallery {
    -webkit-animation-name: fadeOutDown;
    animation-name: fadeOutDown;
  }

  .fade-gallery.in {
    transition: opacity .5s ease;
    -webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
  }

  .controller-gallery{
    color:#fff;
    font-size:28px;
    font-family:arial;
    line-height: 60px;
  }

  .imageCounter {
    display:table;
    margin:0 auto;
    color: #8d8d8d;
  }


  .carousel {
    /*min-height: 550px;*/
    max-height: 1000px;
    overflow: hidden;
    width: 100%;
  }

  .carousel-control {
    width: 16%;
  }

  .modal-body {
    position: relative;
    padding: 10px;
    background: transparent;
  }


  .modal-content {
    /**
     * remove white border around gallery.
    */
    background-color: inherit;
  }

  .modal-content .header {
    height: 25px;
  }

  .arrow{
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    display: inline-block;
    margin-top: 15px;
    position: absolute;
  }

  .arrow-left {
    border-right: 20px solid #f5f5f5;
    float: left;
    margin-left: -25px;

  }

  .arrow-right {
    border-left: 20px solid #f5f5f5;
    float: right;
    margin-left: 5px;
  }

  .carousel-control.right, .carousel-control.left {
    background: none;
  }

  .carousel-control.left {
    text-align: left;
    left: 35px;
  }

  .carousel-control.right {
    text-align: right;
    right: 35px;
  }

  a:hover, a:focus, a:active {
    text-decoration: none;
    border: none !important;
    background: transparent;
    color: transparent;
    outline: none;
  }

  .close {
    opacity: 0.8 !important;
    z-index:1058;
    padding:20px;
  }

  .modal {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    outline: 0;
    background: rgba(0, 0, 0, .5);
    /*background: rgba(255, 255, 255, .85);*/
    /* center modal vertically */
    text-align: center;
    padding: 0 !important;

    transition-duration: 5s;
  }

  /* center modal vertically */
  .modal:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    margin-right: -4px;
  }

  .modal-dialog {
    display: inline-block;
    text-align: left;
    vertical-align: middle;
  }

  button.close {
    outline: none;
    /*outline: aqua;*/
  }

  .closeArea {
    height: 100px;
    width: 100px;
  }

  /*!* Fix the cursor:pointer *!*/
  #myModal1 {
    cursor: auto;
  }


  .fade-custom {
    opacity: 0;
    -webkit-transition: all .25s linear;
    -o-transition: all .25s linear;
    transition: all .25s linear;
  }

  .fade-custom.in {
    opacity: 1;
  }

  /* Override gallery style */
  #app .modal-dialog{
    margin: 0!important;
  }

  #app .modal-content .header{
    height: 0!important;
  }

  #app .modal-body {
    position: relative;
    padding: 0!important;
  }

  #app .modal-body .close{
    position: absolute;
    padding: 0;
    right: 0px;
    top: 0px;
  }
</style>




// WEBPACK FOOTER //
// Gallery.vue?1f248a93